module.exports = __webpack_public_path__ + "img/list.1b234525.svg";